import React, { useContext } from 'react';
import { format } from 'date-fns';

// import { ReactComponent as Logo } from '../../assets/img/logo-header.svg';
import newLogo from '../../assets/img/TotalEnergies_Logo_RGB.png';

import './Header.scss';
import { ReportDateContext } from '../../core/context/report-date-context';
import { PATH_PREFIX } from '../../core/config/config';

export default function Header(): JSX.Element {
  const { reportDate } = useContext(ReportDateContext);
  const search = new URLSearchParams(window.location.search);
  const key = search.get('key');
  const edition = window.sessionStorage.getItem('edition');
  const oppositeEditionKey = window.sessionStorage.getItem('oppositeEditionKey');
  let morningKey;
  let afternoonKey;

  if (key) {
    morningKey = edition === 'Morning' ? key : oppositeEditionKey;
    afternoonKey = edition === 'Morning' ? oppositeEditionKey : key;
  }

  return (
    <div className="Header">
      <div className="total-container">
        <div className="row">
          <div className="Header__logo col-sm-6 fsc">
            {/* <Logo /> */}
            <img src={newLogo} alt="Logo" />
          </div>
          <div className="col-sm-6 fec">
            <div className="Header__content">
              <p className="Header__date">{format(reportDate, 'd MMMM yyyy')}</p>
              <p className="Header__title">Daily Market Review</p>
              {key ? (
                <p className="Header__edition pdf-exclude">
                  <a
                    className={edition === 'Morning' ? 'disabled' : ''}
                    href={`${window.location.origin}${PATH_PREFIX}/?key=${morningKey}`}
                  >
                    Morning Edition
                  </a>
                  {oppositeEditionKey !== 'null' ? (
                    <span>
                      {' '}
                      /{' '}
                      <a
                        className={edition === 'Morning' ? '' : 'disabled'}
                        href={`${window.location.origin}${PATH_PREFIX}/?key=${afternoonKey}`}
                      >
                        Afternoon Edition
                      </a>
                    </span>
                  ) : null}
                </p>
              ) : null}
              <div className="pdf-only">
                <p className="Header__edition-pdf">{edition} Edition</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
